// ** Flatpickr
import Flatpickr from "react-flatpickr"
import "flatpickr/dist/flatpickr.css"

// Functions
import { dateConvert } from "functions"

export const Calendar = ({
  value,
  onChange,
  label = "",
  noLabel = false,
  errors,
  ...rest
}) => (
  <div className="mb-3">
    {!noLabel && <label className="fw-bold">{label}</label>}

    <div>
      <Flatpickr
        {...rest}
        value={new Date(value)}
        onChange={e => onChange(dateConvert(e).default.format)}
        className={`form-control ${errors && 'is-invalid'}`}
      />
    </div>

    {errors && <small className="text-danger">{errors}</small>}
  </div>
)